import { FieldCacheService, NSARouterMaker, NSARouterMakerResult, NSFRouterMaker } from "namirasoft-account-react";
import { NamirasoftAPIProductServer, ProductUUID } from "namirasoft-api-product";
import { EnvService, IStorageSession } from "namirasoft-core";
import { NamirasoftFieldServer } from "namirasoft-field";
import { NSNotFoundPage } from "namirasoft-site-react";
import { useReducer } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { FieldLayout } from "./FieldLayout";
import { FieldRoutes } from "./FieldRoutes";
import CategoryEditPage from "./pages/CategoryEditPage";
import CategoryListPage from "./pages/CategoryListPage";
import CategoryScopeEditPage from "./pages/CategoryScopeEditPage";
import CategoryScopeListPage from "./pages/CategoryScopeListPage";
import CategoryScopeViewPage from "./pages/CategoryScopeViewPage";
import CategoryViewPage from "./pages/CategoryViewPage";
import FieldEditPage from "./pages/FieldEditPage";
import FieldListPage from "./pages/FieldListPage";
import FieldViewPage from "./pages/FieldViewPage";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import SlotEditPage from "./pages/SlotEditPage";
import SlotListPage from "./pages/SlotListPage";
import SlotViewPage from "./pages/SlotViewPage";

function Router()
{
    let [, page_force_update] = useReducer((x) => x + 1, 0);

    let navigate = useNavigate();

    return <NSARouterMaker
        notifier_storage={new IStorageSession()}
        page_force_update={page_force_update}
        product_id={ProductUUID.NAMIRASOFT_FIELD}

        renderOnLogin={(result: NSARouterMakerResult) =>
        {
            let REACT_APP_BASE_URL_FIELD = new EnvService("REACT_APP_BASE_URL_FIELD", true).getString();
            let REACT_APP_BASE_URL_API_PRODUCT = new EnvService("REACT_APP_BASE_URL_API_PRODUCT", true).getString();

            let field = new NamirasoftFieldServer(REACT_APP_BASE_URL_FIELD, result.account.token_manager, result.notifier.onError);
            let product = new NamirasoftAPIProductServer(REACT_APP_BASE_URL_API_PRODUCT, result.notifier.onError);

            let servers = { field, product };

            return (
                <FieldCacheService
                    {...result}
                    render={(rows) => (
                        <Routes>
                            <Route path={FieldRoutes.Home} element={<HomePage {...result} servers={servers} />} />

                            <Route path={FieldRoutes.FieldList} element={<FieldListPage {...result} servers={servers} />} />
                            <Route path={FieldRoutes.FieldNew} element={<FieldEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={FieldRoutes.FieldCopy(":id")} element={<FieldEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={FieldRoutes.FieldEdit(":id")} element={<FieldEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={FieldRoutes.FieldView(":id")} element={<FieldViewPage {...result} servers={servers} />} />

                            <Route path={FieldRoutes.CategoryList} element={<CategoryListPage {...result} servers={servers} />} />
                            <Route path={FieldRoutes.CategoryNew} element={<CategoryEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={FieldRoutes.CategoryCopy(":id")} element={<CategoryEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={FieldRoutes.CategoryEdit(":id")} element={<CategoryEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={FieldRoutes.CategoryView(":id")} element={<CategoryViewPage {...result} servers={servers} />} />

                            <Route path={FieldRoutes.CategoryScopeList} element={<CategoryScopeListPage {...result} servers={servers} />} />
                            <Route path={FieldRoutes.CategoryScopeNew} element={<CategoryScopeEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={FieldRoutes.CategoryScopeCopy(":id")} element={<CategoryScopeEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={FieldRoutes.CategoryScopeEdit(":id")} element={<CategoryScopeEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={FieldRoutes.CategoryScopeView(":id")} element={<CategoryScopeViewPage {...result} servers={servers} />} />

                            <Route path={FieldRoutes.SlotList} element={<SlotListPage {...result} servers={servers} />} />
                            <Route path={FieldRoutes.SlotNew} element={<SlotEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={FieldRoutes.SlotCopy(":id")} element={<SlotEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={FieldRoutes.SlotEdit(":id")} element={<SlotEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={FieldRoutes.SlotView(":id")} element={<SlotViewPage {...result} servers={servers} />} />

                            {NSFRouterMaker.getRoutes({ ...result, rows, children: <></> })}

                            <Route path="*" element={<NSNotFoundPage />} />
                        </Routes >
                    )}
                />
            );
        }}
        renderOnLogout={() => (
            <Routes>
                <Route path={FieldRoutes.Home} element={<LoginPage />} />
                <Route path="*" element={<LoginPage />} />
            </Routes>
        )}
        navigate={navigate}
        getNSALayout={(props) => (
            <FieldLayout {...props}>
                {props.children}
            </FieldLayout>
        )}
        requirement={{
            verification: {
                email: true,
                phone: true
            }
        }}
    />
}

export default Router;